// @ts-nocheck
import { produce, castDraft } from "immer";
import { type CreateConnectionBulkMutation } from "../../../../connections/api/mutation/createConnectionBulk.gql-generated";
import { type LensConnectionsFragment } from "../../../api/fragments/lensConnections.gql-generated";

type Connection = CreateConnectionBulkMutation["createConnectionBulk"]["connections"][0];

export const LensOperations = {
    addConnection(lens: LensConnectionsFragment, connection: Connection) {
        return produce(lens, (draft) => {
            if (draft.connections.every((lensConnection) => lensConnection.connectionId !== connection.connectionId)) {
                draft.connections.push(castDraft(connection));
            }
        });
    },

    removeConnection(lens: LensConnectionsFragment, id: string) {
        return produce(lens, (draft) => {
            draft.connections = draft.connections.filter(({ connectionId }) => connectionId !== id);
        });
    },
};
